export const PUBLIC_BLOG_LIST_REQUEST = 'PUBLIC_BLOG_LIST_REQUEST';
export const PUBLIC_BLOG_LIST_SUCCESS = 'PUBLIC_BLOG_LIST_SUCCESS';
export const PUBLIC_BLOG_LIST_FAIL = 'PUBLIC_BLOG_LIST_FAIL';

export const PUBLIC_BLOG_DETAILS_REQUEST = 'PUBLIC_BLOG_DETAILS_REQUEST';
export const PUBLIC_BLOG_DETAILS_SUCCESS = 'PUBLIC_BLOG_DETAILS_SUCCESS';
export const PUBLIC_BLOG_DETAILS_FAIL = 'PUBLIC_BLOG_DETAILS_FAIL';

export const PUBLIC_BLOG_CREATE_REQUEST = 'PUBLIC_BLOG_CREATE_REQUEST';
export const PUBLIC_BLOG_CREATE_SUCCESS = 'PUBLIC_BLOG_CREATE_SUCCESS';
export const PUBLIC_BLOG_CREATE_FAIL = 'PUBLIC_BLOG_CREATE_FAIL';
export const PUBLIC_BLOG_CREATE_RESET = 'PUBLIC_BLOG_CREATE_RESET';

export const PUBLIC_BLOG_REVIEW_CREATE_REQUEST = 'PUBLIC_BLOG_REVIEW_CREATE_REQUEST';
export const PUBLIC_BLOG_REVIEW_CREATE_SUCCESS = 'PUBLIC_BLOG_REVIEW_CREATE_SUCCESS';
export const PUBLIC_BLOG_REVIEW_CREATE_FAIL = 'PUBLIC_BLOG_REVIEW_CREATE_FAIL';
export const PUBLIC_BLOG_REVIEW_CREATE_RESET = 'PUBLIC_BLOG_REVIEW_CREATE_RESET';

export const PUBLIC_BLOG_UPDATE_REQUEST = 'PUBLIC_BLOG_UPDATE_REQUEST';
export const PUBLIC_BLOG_UPDATE_SUCCESS = 'PUBLIC_BLOG_UPDATE_SUCCESS';
export const PUBLIC_BLOG_UPDATE_FAIL = 'PUBLIC_BLOG_UPDATE_FAIL';
export const PUBLIC_BLOG_UPDATE_RESET = 'PUBLIC_BLOG_UPDATE_RESET';

export const PUBLIC_BLOG_DELETE_REQUEST = 'PUBLIC_BLOG_DELETE_REQUEST';
export const PUBLIC_BLOG_DELETE_SUCCESS = 'PUBLIC_BLOG_DELETE_SUCCESS';
export const PUBLIC_BLOG_DELETE_FAIL = 'PUBLIC_BLOG_DELETE_FAIL';
export const PUBLIC_BLOG_DELETE_RESET = 'PUBLIC_BLOG_DELETE_RESET';